export default __webpack_public_path__ + "vietnam-map-500-b97cbc31737f449660c216b575819e2d.png";